/**
 * Import automatiquement toutes les ressources trouvées sous l'arborescence plugins
 */
import Vue from 'vue';
import '@/config';

const listFile = require.context('../plugins/', true, /\.js$/);

console.info({keys: listFile.keys()}); //eslint-disable-line
listFile.keys().forEach((insKey) => {
  const tabMatched = insKey.match(/(index.js)/);

  if (tabMatched && tabMatched.length > 0) {
    console.log('fichier exclu : ' + tabMatched[1]);  // eslint-disable-line
  } else {
    const oRequire = listFile(insKey);
    const sValue = oRequire.name;
    Vue.use(oRequire.default, typeof sValue === 'object' ? sValue : undefined);
  }
});
